import {useAuth} from "@bounce/shared/contexts";
import {useConsumerMenu} from "../../context/MenuContext";
import {isPreLoginRole} from "~/helpers/roles";

export const useExternalLinksOptions = () => {
  const {loggedIn, userRole} = useAuth();
  const {trackAndCloseMenu} = useConsumerMenu();

  const handleExternalLink = (trackingKey: string, url: string) => () => {
    trackAndCloseMenu(trackingKey);
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return {
    shouldDisplayExternalLinksOptions: !loggedIn && !isPreLoginRole(userRole),
    handleExternalLink,
    onTermsAndConditionsClick: handleExternalLink(
      "terms_and_conditions",
      "https://www.bounceai.com/terms-and-conditions"
    ),
    onStateNoticeClick: handleExternalLink("state_notice", "https://www.bounceai.com/state-notices"),
    onNMLSClick: handleExternalLink("nmls", "https://www.bounceai.com/licenses"),
  };
};
